import * as moment from "moment";
import 'moment/locale/pt-br';

export class UtilsHelper {

  formatarValor(valor: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  }

  formatarCpfCnpj(documento): string {
    if(documento.length > 11) {
      return '00.000.000/0000-00';
    } else {
      return '000.000.000-00';
    }
  }

  cpfCnpj(value: string): string {
    if (!value) return '';
    if(value === undefined || value === null) return '';
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 11) {
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      return cleaned.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
      );
    }
  }
}
